import { PageHeader, Card, CardHeader, AtomBadge } from "../components/primitives";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, ScatterChart, Scatter, ZAxis } from "recharts";

const SEGMENTS = [
  {label:"Salary earners · Lagos retail · mobile-heavy",color:"#0B2B5C",count:480,data:Array.from({length:80},(_,i)=>({x:30+i%12*4,y:35+Math.floor(i/12)*5,z:1}))},
  {label:"Cross-border traders · Lagos/Ibadan",color:"#F59A2D",count:120,data:Array.from({length:40},(_,i)=>({x:70+i%10*2,y:60+Math.floor(i/10)*5,z:1}))},
  {label:"PEP-adjacent high-value",color:"#C2410C",count:40,data:Array.from({length:25},(_,i)=>({x:80+i%5*3,y:80+Math.floor(i/5)*3,z:1}))},
  {label:"Cash-intensive market trader · North",color:"#B7791F",count:210,data:Array.from({length:60},(_,i)=>({x:20+i%10*3,y:55+Math.floor(i/10)*4,z:1}))},
];

const ANOMALY_TREND = Array.from({length:90},(_,i) => ({day: i, signal: 30 + Math.sin(i/8)*10 + (i > 70 ? (i-70)*1.5 : 0) + Math.random()*5}));

export default function BehaviouralAnalytics() {
  return (
    <div>
      <PageHeader
        title="Behavioural Analytics"
        subtitle="Customer segmentation · anomaly trends · emerging patterns"
        sections={["5.4","5.5"]}
        atom={<AtomBadge model="Atom Proton" version="v2.4" description="Behavioural clustering and anomaly detection" />}
      />
      <div className="p-6 grid grid-cols-2 gap-3">
        <Card className="col-span-2">
          <CardHeader title="Customer segmentation" subtitle="Behavioural clusters across the customer base" />
          <div className="p-3 h-[360px]">
            <ResponsiveContainer>
              <ScatterChart margin={{top:10,right:10,left:-10,bottom:10}}>
                <CartesianGrid strokeDasharray="2 2" stroke="#E5E5E0" />
                <XAxis dataKey="x" name="Risk index" tick={{fontSize:10,fill:'#5C5C57'}} type="number" domain={[0,100]} axisLine={false} />
                <YAxis dataKey="y" name="Activity index" tick={{fontSize:10,fill:'#5C5C57'}} type="number" domain={[0,100]} axisLine={false} />
                <ZAxis dataKey="z" range={[20,60]} />
                <Tooltip contentStyle={{fontSize:11,border:'1px solid #E5E5E0',borderRadius:4}} />
                {SEGMENTS.map(s => <Scatter key={s.label} name={s.label} data={s.data} fill={s.color} />)}
              </ScatterChart>
            </ResponsiveContainer>
          </div>
          <div className="px-3 pb-3 grid grid-cols-4 gap-2">
            {SEGMENTS.map(s => (
              <div key={s.label} className="flex items-center gap-2 border border-line rounded-sm p-2">
                <span className="w-2 h-2 rounded-full" style={{background: s.color}} />
                <div>
                  <div className="text-[11px] font-medium">{s.label}</div>
                  <div className="text-[10px] text-ink-subtle">{s.count.toLocaleString()} customers</div>
                </div>
              </div>
            ))}
          </div>
        </Card>
        <Card>
          <CardHeader title="Anomaly signal · 90 days" />
          <div className="p-3 h-[240px]">
            <ResponsiveContainer>
              <LineChart data={ANOMALY_TREND}>
                <CartesianGrid strokeDasharray="2 2" stroke="#E5E5E0" vertical={false} />
                <XAxis dataKey="day" tick={{fontSize:10,fill:'#5C5C57'}} axisLine={false} tickLine={false} />
                <YAxis tick={{fontSize:10,fill:'#5C5C57'}} axisLine={false} tickLine={false} />
                <Tooltip contentStyle={{fontSize:11}} />
                <Line type="monotone" dataKey="signal" stroke="#0B2B5C" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card>
          <CardHeader title="Emerging patterns · last 30 days" />
          <div className="p-3 text-[12px] space-y-2">
            {[
              ["Smurfing across newly opened mule accounts", "+18% wow", "T1007"],
              ["Round-trip via fintech wallet (ZipPay, SwiftPay)", "+12% wow", "T1102"],
              ["Cross-border high-velocity to UAE/Dubai", "+8% wow", "T1105"],
              ["Cash deposits just under ₦5M CTR threshold", "+6% wow", "T1003"],
              ["PEP family channelling via federal contractors", "+4% wow", "T0907"],
            ].map(([t, d, c], i) => (
              <div key={i} className="border border-line rounded-sm p-2 flex items-center justify-between">
                <div>
                  <div className="font-medium">{t}</div>
                  <div className="text-[10px] text-ink-subtle">{c}</div>
                </div>
                <span className="text-[11px] text-risk-high font-medium">{d}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
